import { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { ProtectedRoute } from "@/components/ProtectedRoute";

export const useBilling = () => {
  const [billing, setBilling] = useState(null);
  const load = useCallback(() => api.get("/billing/me").then(({ data }) => setBilling(data)).catch(() => setBilling({ active: false })), []);
  useEffect(() => { load(); }, [load]);
  return { billing, reload: load };
};

const Gate = ({ children }) => {
  const { billing } = useBilling();
  if (!billing) return <div className="min-h-screen grid place-items-center blueprint-grid" data-testid="billing-loading"><Loader2 className="animate-spin text-[var(--cyan)]" /></div>;
  if (!billing.active) return <Navigate to="/subscribe" replace />;
  return children;
};

export const MemberRoute = ({ children }) => <ProtectedRoute><Gate>{children}</Gate></ProtectedRoute>;

export const startCheckout = async (path, body = {}) => {
  const { data } = await api.post(path, { ...body, origin_url: window.location.origin });
  if (data.checkout_url) window.location.href = data.checkout_url;
  return data;
};

export const confirmCharge = (billing, amount) => !billing?.card || billing.is_admin
  || window.confirm(`Charge ${money(amount)} to your ${billing.card.brand} card ending ${billing.card.last4}?`);

export const parseSqft = (text) => {
  const m = text.match(/(\d{1,2},?\d{3}|\d{3,5})\s*(\+\s*)?(sq\.?\s*f(ee)?t|square\s*f(oo|ee)t|sf|sqft|ft²|ft2)/i);
  return m ? Number(m[1].replace(",", "")) : null;
};

export const money = (v) => `$${Number(v).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
